module.exports = __webpack_public_path__ + "img/bg04.07e6ccc7.gif";